import { statsData, brandHistory, testimonials } from '@/mocks/siteData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '极速高清',
    url: 'https://movihubs.github.io',
    description: '极速高清在线视频平台，提供高清影视、综艺、纪录片在线观看服务',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-8888',
      contactType: 'customer service',
      email: 'contact@jisugaoqing.com',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '望京科技园',
    },
  };

  const jsonLdAbout = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于极速高清 - 在线观看高清视频平台',
    description: '了解极速高清的品牌故事、发展历程、用户口碑和联系方式',
    url: 'https://movihubs.github.io/about',
  };

  const formUrl = 'https://readdy.ai/api/form/d9u3bml3pcjqs2fcsl5g';

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdOrg)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdAbout)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16 min-h-screen">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
              关于极速高清
            </h1>
            <p className="text-foreground-500 text-sm mt-2">
              了解我们的品牌故事与发展历程
            </p>
          </div>
        </div>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="flex-1">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
                  <i className="ri-building-line"></i>
                  品牌介绍
                </div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  让每个人都能畅享高清在线观看体验
                </h2>
                <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
                  <p>
                    极速高清成立于2018年，是一家专注于在线视频内容服务的高科技企业。我们的使命是"让每个人都能畅享高清视频"，通过先进的技术和丰富的内容，为用户提供极致流畅的在线观看体验。
                  </p>
                  <p>
                    经过六年的深耕发展，极速高清已成为中国领先的在线观看平台之一，服务用户覆盖全球150多个国家和地区。我们始终坚持"内容为王、技术驱动、用户至上"的核心价值观，不断创新突破。
                  </p>
                  <p>
                    平台汇聚了10万+优质视频资源，涵盖电影、电视剧、综艺、动漫、纪录片、体育等丰富品类，满足不同用户群体的多元化观看需求。我们采用行业领先的CDN加速技术和智能编码技术，确保每一位用户都能享受极速、高清、稳定的在线观看体验。
                  </p>
                </div>
              </div>
              <div className="flex-1">
                <div className="grid grid-cols-2 gap-4">
                  {statsData.map((stat) => (
                    <div key={stat.label} className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                      <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.value}</p>
                      <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
                <i className="ri-timeline-view"></i>
                发展历程
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                我们的成长之路
              </h2>
            </div>
            <div className="space-y-0">
              {brandHistory.map((item, index) => (
                <div key={item.year} className="flex gap-6">
                  <div className="flex flex-col items-center">
                    <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-primary-500 text-background-50 rounded-full font-bold text-sm">
                      {item.year}
                    </div>
                    {index < brandHistory.length - 1 && (
                      <div className="w-0.5 flex-1 bg-background-300 my-2"></div>
                    )}
                  </div>
                  <div className="pb-8 pt-3">
                    <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{item.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
                <i className="ri-hearts-line"></i>
                用户口碑
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                听听用户怎么说
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((item) => (
                <div key={item.id} className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-11 h-11 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                      <p className="text-xs text-foreground-400">{item.date}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${i < item.rating ? 'text-secondary-400' : 'text-background-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.comment}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
                <i className="ri-mail-send-line"></i>
                联系我们
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                期待您的来信
              </h2>
              <p className="text-foreground-500 text-sm">
                如有任何问题或合作意向，请随时联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center bg-primary-100 rounded-full mb-3">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h4>
                <p className="text-xs text-foreground-500">contact@jisugaoqing.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-3">
                  <i className="ri-phone-line text-lg text-accent-600"></i>
                </div>
                <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">客服电话</h4>
                <p className="text-xs text-foreground-500">400-888-8888</p>
              </div>
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-11 h-11 mx-auto flex items-center justify-center bg-secondary-100 rounded-full mb-3">
                  <i className="ri-map-pin-line text-lg text-secondary-600"></i>
                </div>
                <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-1">公司地址</h4>
                <p className="text-xs text-foreground-500">北京市朝阳区望京科技园</p>
              </div>
            </div>

            <form
              action={formUrl}
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8"
              data-readdy-form=""
              id="contact-form-about"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                  placeholder="请输入主题"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
                  placeholder="请输入您的留言（不超过500字）"
                ></textarea>
              </div>
              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                className="w-full px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill mr-2"></i>
                发送留言
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}